
export type FileFolder = {
    id:string,
    name:string,
    parentFileFolderId:string | null,
    files:{
        publicFileName:string,
        privateFileName:string,
        size:number,
        created:Date,
        isShared:boolean
    }[]
}

export type FileFolderNode = 
    FileFolder &
    {
        children: FileFolderNode[]
    }

export function getChildFoldersRecursively(folderId:string|null, allFolders:FileFolder[]):FileFolder[]
{
    const allChildren:FileFolder[] = [];
    const directionChildren = allFolders.filter(f => f.parentFileFolderId === folderId);
    for(const child of directionChildren)
    {
        allChildren.push(child);
        allChildren.push(...getChildFoldersRecursively(child.id, allFolders));
    }
    return allChildren;
}